import apiClient from '@/lib/apiClient';
import type { ApiResponse } from '@/lib/apiClient';
import type { Country } from './types';

export async function fetchCountries(isOnlyActive: '0' | '1' = '1'): Promise<Country[]> {
  const { data } = await apiClient.get<ApiResponse<Country[]>>(`/api/countries/${isOnlyActive}`);
  if (!data.success) throw new Error('Ошибка загрузки стран');
  return data.response ?? [];
}
